export const isSsr = typeof window === "undefined";
